import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "news_big"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "公告",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
    finished: $setup.finished,
    "finished-text": "没有更多了",
    onLoad: $setup.loadData
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "news_list",
        key: key
      }, [_createVNode(_component_router_link, {
        to: "/news/show?id=" + item.id
      }, {
        default: _withCtx(() => [_createElementVNode("dl", null, [_createElementVNode("dt", null, _toDisplayString(item.title), 1), _createElementVNode("dd", null, _toDisplayString(item.uptime), 1)])]),
        _: 2
      }, 1032, ["to"])]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])])], 64);
}